import { getWindowData } from 'owa-window-data';

export function isStandaloneMyOutlook(): boolean {
    // Today reuses the hosted vdir, but boots and authenticates as a web document.
    return /^\/hosted\/myoutlook(?:\/|$)/i.test(getWindowData()?.location?.pathname ?? '');
}
